import { all, put, takeEvery } from "redux-saga/effects";
import { removeStatus } from "./action";

function* setErrorStatusWorker(action) {
  try {
    const code = action.payload?.code || "error";
    const message =
      action.payload?.message ||
      "Something went wrong. Please try again later.";

    yield put({ type: "SET_STATUS", payload: { code, message } });
    setTimeout(() => { removeStatus(); }, 4000);
  } catch {}
}

function* setSuccessStatusWorker(action) {
  try {
    yield put({ type: "SET_STATUS", payload: { code: null, message: action.payload.message } });
    setTimeout(() => { removeStatus(); }, 4000);
  } catch {}
}

function* clearStatusWorker() {
  yield put({ type: "REMOVE_STATUS" });
}

export default function* statusWatcher() {
  yield all([
    takeEvery("SET_ERROR_STATUS", setErrorStatusWorker),
    takeEvery("SET_SUCCESS_STATUS", setSuccessStatusWorker),
    takeEvery("CLEAR_STATUS", clearStatusWorker)
  ]);
}
